import { FormlyFieldConfig } from '@ngx-formly/core';
import { PaginateOptions } from '../types';
import { Role } from '../core';

export const MIN_PASSWORD_LEN = 8;
export type QuestionnaireType = 'employer_registration_form' | 'employer_scoping' | 'employer_pra_scoping' | 'employer_saq' | 'recruitment_saq';
export type NotificationType = 'onboarding' | 'hotel_request_link_to_hotel_group' | 'hotel_group_request_link_to_hotel'
    | 'employer_scoping_submitted' | 'hotel_accept_request_link_to_hotel_group' | 'myself_accept_request_link_to_hotel' | 'hotel_reject_request_link_to_hotel_group'
    | 'hotel_group_reject_request_link_to_hotel' | 'myself_accept_request_link_to_hotel_group' | 'hotel_group_accept_request_link_to_hotel';

export interface Card {
    title: string;
    data: CardData;
    cardType: CARDTYPE;
}

export interface CardData {
    buttons: CardButton[];
}

export interface CardButton {
    label: string;
    navigateUrl: string;
    icon: string;
}

export enum CARDTYPE {
    DEFAULT,
}

export interface DataTableConfig<T> {
    data: Array<T>;
    columns: Array<DataTableConfigColumn<T>>;
    actions?: Array<DataTableConfigACtion<T>>;
    mergeActionColumns?: boolean;
    actionStyle?: { [key: string]: any };
    meta: DataTableConfigMeta;
    pageChange: (info: PaginateOptions) => void;
    tableName?: string;
    filterKeys?: string[];
    hideFilter?: boolean;
    hidePaginator?: boolean;
}

export interface DataTableConfigColumn<T> {
    text: string;
    label: string;
    fieldName: string;
    condition?: (element: T) => boolean;
    valueFunction?: (element: T) => string;
    templateFunction?: (element: T) => string;
    style?: { [key: string]: any };
    actionFunction?: ($event: Event, element: T) => void;
    styleClassFunction?: (element: T) => string;
    sortable?: boolean;
}

export interface DataTableConfigACtion<T> {
    text: string;
    label: string;
    fieldName: string;
    condition?: (element: T) => boolean;
    actionFunction?: ($event: Event, element: T) => void;
    style?: { [key: string]: any };
    valueFunction?: (element: T) => string;
    displayIcon?: boolean;
    iconValue?: string;
}

export interface DataTableConfigMeta {
    pageSize: number;
    rowsNumber: number;
    startAtPage?: { pageIndex: number };
}

export interface CustomFormlyFieldConfig extends FormlyFieldConfig {
    questionId?: string;
    fieldGroup?: CustomFormlyFieldConfig[];
    partialId?: string;
}

export type FormlyFieldLayout = 'default' | 'modern' | undefined;

export interface GridReportOptions {
    labelHeader: string;
    columns: GridReportColumnOption[];
}


export interface GridReportColumnOption {
    name: string;
    valueFn?: Function
}

export interface FileInfo {
    id?: string;
    fileName: string;
    fileSize: number;
    fileUrl: string;
    fileSizeDisplay?: string;
}

export interface AttachmentDownloadResponse<T> {
    body: T | null;
    contentDisposition: string;
    contentType: string;
}

export type BaseResponse<T> = {
    data?: T;
    message: string;
    errorCode: any;
    parameters: any;
    status: boolean;
};

export type Organization = {
    id: number;
    name: string;
    logo: string | null;
    url: string;
    status: number;
    language: string;
    simulationTypeId: number;
    level: number;
}

export enum UserStatus {
    ARCHIVED,
    COMPROMISED,
    CONFIRMED,
    FORCE_CHANGE_PASSWORD,
    RESET_REQUIRED,
    UNCONFIRMED,
    UNKNOWN
}

export type User = {
    id: number,
    email: string,
    name: string,
    givenName: string,
    phoneNumber: string,
    status: UserStatus,
    createdDate: string,
    lastModifiedDate: string
    organizations: Organization[];
    username: string,
    role: Role,
}

export enum SIMULATION_EVENT {
    STUDENT_JOIN = 'student_join',
    STUDENT_LEAVE = 'student_leave',
    SIMULATION_START = 'simulation_start',
    SIMULATION_END = 'simulation_end',
    FEEDBACK = 'simulation_feedback',
    PUBLISH = 'simulation_publish',
}

export type AddAdminRequest = {
    email: string;
    role: Role;
    name: string;
    phoneNumber: string;
}
